import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mic, ChevronRight } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const COPY = {
  ready: ["Your voice is ready", "New installations speak in your own voice."],
  processing: ["Creating your voice…", "Usually under a minute."],
  default: ["Create my voice", "Read a short passage once — hear every installation as you."],
};

// Entry to My voice; the page itself offers the trial or subscription when not yet enabled.
export const VoiceCloneEntry = () => {
  const nav = useNavigate();
  const [me, setMe] = useState(null);
  useEffect(() => {
    fetch(`${API}/api/voice-clone/me`, { headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } })
      .then((r) => (r.ok ? r.json() : { enabled: false }))
      .then(setMe)
      .catch(() => setMe({ enabled: false }));
  }, []);
  if (!me) return null;
  const [title, line] = me.enabled ? (COPY[me.status] || COPY.default) : COPY.default;
  return (
    <button type="button" onClick={() => nav("/voice-clone")} data-testid="voice-clone-entry"
      className="w-full text-left rounded-2xl px-5 py-4 flex items-center gap-4 transition-transform duration-200 active:scale-[0.99]"
      style={{ border: "1px solid rgba(215,187,122,0.45)", background: "rgba(215,187,122,0.06)" }}>
      <span className="inline-flex items-center justify-center rounded-full shrink-0" style={{ width: 40, height: 40, border: "1px solid #d7bb7a", color: "#d7bb7a" }}>
        <Mic size={16} />
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-[0.58rem] uppercase tracking-[0.28em]" style={{ color: "#c8a45a", fontFamily: '"Manrope", sans-serif' }}>My voice</span>
        <span className="block text-[1.2rem] font-light" style={{ color: "#f5ecd9", fontFamily: '"Cormorant Garamond", serif' }} data-testid="voice-clone-entry-title">{title}</span>
        <span className="block text-[0.85rem] italic" style={{ color: "rgba(245,236,217,0.72)", fontFamily: '"Cormorant Garamond", serif' }}>{line}</span>
      </span>
      <ChevronRight size={16} color="#d7bb7a" />
    </button>
  );
};
